<template>
  <hm-content title="" ref="hmcontent">
    <div class="mb20 flex flex-between">
      <div>
        <el-radio-group
          v-model="searchCondition.status"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="tiXian">申报明细</el-radio-button>
          <el-radio-button label="menDian">门店统计</el-radio-button>
          <el-radio-button label="daoGou">导购统计</el-radio-button>
          <el-radio-button label="goods">商品统计</el-radio-button>
          <el-radio-button label="mingxi">供货商明细</el-radio-button>
          <!-- <el-radio-button label="jiLu">拦截记录</el-radio-button> -->
        </el-radio-group>
      </div>
      <div>
        当前商户: <span class="primary">{{ storeNames }}</span>
      </div>
    </div>
    <div class="table-panel flex flex-end">
      <div>
        <!-- <el-cascader
          clearable
          style="marginRight:10px"
          ref="cascader"
          v-model="searchCondition.storeOrShopIds"
          :props="props"
          filterable
          :show-all-levels="false"
          size="small"
          placeholder="请选择商户"
        ></el-cascader> -->
        <el-select
          size="small"
          clearable
          class="mr10"
          multiple
          placeholder="请选择门店"
          v-model="searchCondition.shopIdList"
          filterable
        >
          <el-option
            :label="v.shopName"
            :value="v.shopId"
            v-for="(v, i) in shopList"
            :key="i"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="searchCondition.status === 'mingxi'"
          size="small"
          clearable
          class="mr10"
          placeholder="请选择供货商"
          v-model="searchCondition.supplierCode"
          filterable
        >
          <el-option
            :label="v.supplierName"
            :value="v.supplierCode"
            v-for="(v, i) in allSupplierList"
            :key="i"
          >
          </el-option>
        </el-select>

        <el-select
          v-if="
            searchCondition.status === 'goods' ||
              searchCondition.status === 'mingxi'
          "
          size="small"
          clearable
          placeholder="选择品牌"
          v-model="searchCondition.brandNameList"
          class="mr10"
          filterable
          multiple
        >
          <el-option
            v-for="(item, i) in allHemiaoBrand"
            :key="i"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-input
          v-if="searchCondition.status === 'goods'"
          clearable
          v-model.trim="searchCondition.goodsKeyWords"
          placeholder="请输入商品名/货号/条码"
          size="small"
          class="mr10"
          style="width:200px"
        ></el-input>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.receiptDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择小票时间时间段"
          end-placeholder="选择小票时间时间段"
        ></el-date-picker>
        <el-input
          v-if="
            searchCondition.status === 'tiXian' ||
              searchCondition.status === 'daoGou'
          "
          clearable
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入导购名称/手机号"
          size="small"
          style="width:270px;"
          class="mr10"
        ></el-input>
        <el-cascader
          class="mr10"
          :options="area"
          size="small"
          v-if="
            searchCondition.status === 'menDian' ||
              searchCondition.status === 'daoGou'
          "
          ref="citys"
          clearable
          placeholder="请选择省市区"
          v-model="searchCondition.citys"
          :props="propsCity"
        >
        </el-cascader>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择扣费时间段"
          end-placeholder="选择扣费时间段"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table" v-if="searchCondition.status === 'tiXian'">
      <el-table
        :data="commissionReportList.records"
        style="width: 100%"
        ref="tixian"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报单号"
          prop="billSn"
          column-key="billSn"
        >
          <template slot-scope="scope">
            {{ scope.row.billSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票"
          prop="receiptSn"
          column-key="receiptSn"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="交易时间"
          prop="receiptTime"
          column-key="receiptTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报时间"
          prop="declareTime"
          column-key="declareTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
          column-key="citys"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="供货商"
          column-key="supplierName"
        >
          <template slot-scope="scope">
            {{ scope.row.supplierName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
          column-key="shopName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="导购姓名"
          column-key="guiderName"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="手机号"
          column-key="guiderPhone"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandNames"
          label="商品品牌"
          column-key="brandNames"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNames"
          label="商品"
          column-key="goodsNames"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.goodsNames }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNumSum"
          label="销售数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="redpackageMoneySum"
          label="提成金额"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoney"
          label="平台服务费"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tradeTime"
          label="扣费时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="declareImg"
          label="小票照片"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.declareImgList[0]"
                :preview-src-list="scope.row.declareImgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="commissionReportList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-if="searchCondition.status === 'menDian'">
      <el-table
        :data="shopReportList.records"
        style="width: 100%"
        ref="mendian"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户"
        >
          <template slot-scope="scope">
            {{ scope.row.storeName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
        >
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNumSum"
          label="销售数量"
        >
          <template slot-scope="scope">
            {{ scope.row.goodsNumSum }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopPercent"
          label="单店红包占比"
        >
          <template slot-scope="scope"> {{ scope.row.shopPercent }}% </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="detaisIdCount"
          label="申报单数"
        >
          <template slot-scope="scope">
            {{ scope.row.detaisIdCount }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="redpackageMoneySum"
          label="发放金额"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoneys"
          label="平台服务费"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoneys }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="shopReportList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-if="searchCondition.status === 'daoGou'">
      <el-table
        :data="guiderReportList.records"
        style="width: 100%"
        ref="daogou"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
          column-key="citys"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户"
          column-key="storeName"
        >
          <template slot-scope="scope">
            {{ scope.row.storeName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
          column-key="shopName"
        >
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="导购名称"
          column-key="guiderName"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="导购电话"
          column-key="guiderPhone"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderPhone }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="receiptCount"
          label="销量申报数"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptCount }}
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNumSum"
          label="销售数量"
          column-key="goodsNumSum"
        >
          <template slot-scope="scope">
            {{ scope.row.goodsNumSum }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="detaisIdCount"
          label="申报单数"
          column-key="detaisIdCount"
        >
          <template slot-scope="scope">
            {{ scope.row.detaisIdCount }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="redpackageMoneySum"
          label="发放金额"
          column-key="redpackageMoneySum"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoneys"
          label="平台服务费"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoneys }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="guiderReportList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-show="searchCondition.status === 'goods'">
      <el-table
        :data="goodsReportList.records"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="申报单号"
          prop="declareSn"
          column-key="declareSn"
        >
          <template slot-scope="scope">
            {{ scope.row.declareSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票日期"
          prop="receiptTime"
          column-key="receiptTime"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票时间"
          prop="receiptDateStr"
          column-key="receiptDateStr"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptDateStr }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报时间"
          prop="declareTime"
          column-key="declareTime"
        >
          <template slot-scope="scope">
            {{ scope.row.declareTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
          column-key="citys"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="供货商"
          column-key="supplierName"
        >
          <template slot-scope="scope">
            {{ scope.row.supplierName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
          column-key="shopName"
        >
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="导购姓名"
          column-key="guiderName"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="手机号"
          column-key="guiderPhone"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandNames"
          label="商品品牌"
          column-key="brandNames"
        >
          <template slot-scope="scope">
            {{ scope.row.brandNames }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNames"
          label="商品"
          column-key="goodsNames"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.goodsNames }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNumSum"
          label="销售数量"
          column-key="goodsNumSum"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票"
          prop="receiptSn"
          column-key="receiptSn"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptSn }}
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="goodsReportList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-show="searchCondition.status === 'mingxi'">
      <el-table
        :data="reportListGroup"
        style="width: 100%"
        ref="mingxi"
        stripe
        border
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报单号"
          prop="declareSn"
          column-key="declareSn"
        >
          <template slot-scope="scope">
            {{ scope.row.declareSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票日期"
          prop="receiptTime"
          column-key="receiptTime"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptTime }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="小票时间"
          prop="receiptDateStr"
          column-key="receiptDateStr"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptDateStr }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="申报时间"
          prop="declareTime"
          column-key="declareTime"
        >
          <template slot-scope="scope">
            {{ scope.row.declareTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
          column-key="citys"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="供货商"
          column-key="supplierName"
        >
          <template slot-scope="scope">
            {{ scope.row.supplierName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
          column-key="shopName"
        >
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="导购姓名"
          column-key="guiderName"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="手机号"
          column-key="guiderPhone"
        >
          <template slot-scope="scope">
            {{ scope.row.guiderPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandNames"
          label="商品品牌"
          column-key="brandNames"
        >
          <template slot-scope="scope">
            {{ scope.row.brandNames }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNames"
          label="商品"
          column-key="goodsNames"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.goodsNames }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNumSum"
          label="销售数量"
          column-key="goodsNumSum"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="redpackageMoneySum"
          label="提成金额"
          column-key="redpackageMoneySum"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoney"
          label="平台服务费"
          column-key="percentageMoney"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoney }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="tradeTime"
          label="扣费时间"
          column-key="tradeTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="小票"
          prop="receiptSn"
          column-key="receiptSn"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="declareImg"
          label="小票照片"
          column-key="declareImg"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.declareImgList[0]"
                :preview-src-list="scope.row.declareImgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="reportListGroupTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <!-- <div class="table" v-if="searchCondition.status === 'daoGou'">
      <el-table
        :data="[]"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="发放时段"
          prop="templateCode"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市"
          prop="templateType"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="商户"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="导购名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="导购电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="销量申报数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="售卖商品数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="发红包数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="发放金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="平台服务费"
        >
        </el-table-column>
      </el-table>
    </div> -->
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      area,
      propsCity: {
        value: "value",
        children: "children"
      },
      //   props: {
      //     lazy: true,
      //     checkStrictly: true,
      //     multiple: true,
      //     lazyLoad: (node, resolve) => {
      //       const { level, data } = node;
      //       if (level === 0) {
      //         this.$store
      //           .dispatch("queryStoreBasicInfoTree", {
      //             pageNo: 1,
      //             pageSize: 999
      //           })
      //           .then(res => {
      //             res.result.forEach(v => {
      //               v.leaf = Boolean(v.shopCount > 0 ? false : true);
      //               v.value = v.storeCode;
      //               v.label = v.storeName;
      //             });
      //             resolve(res.result);
      //           });
      //       } else if (level === 1) {
      //         this.$store
      //           .dispatch("queryStoreShopInfoTree", {
      //             storeCode: data.storeCode
      //           })
      //           .then(res => {
      //             if (res.code === "0" && res.result) {
      //               res.result.forEach(v => {
      //                 v.leaf = true;
      //                 v.value = v.shopId;
      //                 v.label = v.shopName;
      //               });
      //               resolve(res.result);
      //             } else {
      //               resolve([]);
      //             }
      //           });
      //       } else {
      //         resolve([]);
      //       }
      //     }
      //   },
      searchCondition: {
        status: "tiXian",
        receiptDate: []
      },
      currentPage: 1,
      pageSize: 10,
      num: 0,
      storeNames: "",
      isOutputing: false,
      shopList: [],
      goodsReportList: {},
      reportListGroup: [],
      reportListGroupTotal: 0,
      allHemiaoBrand: [],
      allSupplierList: [],
      resetForm: true,
    };
  },
  computed: mapGetters([
    "commissionReportList",
    "shopReportList",
    "guiderReportList",
    "allCommissionReportList"
  ]),
  watch: {},
  created() {},
  mounted() {
    const startTime = moment(
      moment()
        .month(moment().month())
        .startOf("month")
        .valueOf()
    ).format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment(
      moment()
        .month(moment().month())
        .endOf("month")
        .valueOf()
    ).format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.receiptDate = [startTime, endTime];
    this.queryList();
    // this.queryAllList();
    this.queryShopIdList();
    this.queryAllHemiaoBrandComboBoxByStore();
    this.findStoreRelationSupplier();
    this.storeNames = localStorage.getItem("shName");
  },
  methods: {
    async findStoreRelationSupplier() {
      let params = {
        storeCode: this.$route.query.storeCode
      };
      const { result, code } = await this.$store.dispatch(
        "findStoreRelationSupplier",
        params
      );
      if (code === "0") {
        this.allSupplierList = result;
      }
    },
    async queryAllHemiaoBrandComboBoxByStore() {
      let params = {
        storeCode: this.$route.query.storeCode
      };
      const { result, code } = await this.$store.dispatch(
        "queryAllHemiaoBrandComboBoxByStore",
        params
      );
      if (code === "0") {
        this.allHemiaoBrand = result;
      }
    },
    async queryShopIdList() {
      let params = {
        storeCode: this.$route.query.storeCode
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopInfoTree",
        params
      );
      this.shopList = result;
    },
    switchTab(val) {
      this.resetForm = false
      this.$nextTick(()=>{
          this.resetForm = true;
      })
      this.commissionReportList.records = [];
      this.commissionReportList.total = 0;

      this.shopReportList.records = [];
      this.shopReportList.total = 0;

      this.guiderReportList.records = [];
      this.guiderReportList.total = 0;

      this.goodsReportList.records = [];
      this.goodsReportList.total = 0;

      this.reportListGroup = [];
      this.reportListGroupTotal = 0;
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (val === "tiXian") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.checkedRow = [];
          this.queryList();
        } else if (val === "menDian") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryShopList();
        } else if (val === "daoGou") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryGuiderList();
        } else if (val === "goods") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryGoodsList();
        } else if (val === "mingxi") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.checkedRow = [];
          this.queryReportListGroup();
        }
      } else {
        this.$message({
          message: "请选择小票时间段!",
          type: "warning"
        });
      }
    },
    search() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          this.queryList();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.queryGoodsList();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup();
        }
      } else {
        this.$message({
          message: "请选择小票时间段!",
          type: "warning"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      if (this.searchCondition.status === "tiXian") {
        this.queryList();
      } else if (this.searchCondition.status === "menDian") {
        this.queryShopList();
      } else if (this.searchCondition.status === "daoGou") {
        this.queryGuiderList();
      } else if (this.searchCondition.status === "goods") {
        this.queryGoodsList();
      } else if (this.searchCondition.status === "mingxi") {
        this.queryReportListGroup();
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      if (this.searchCondition.status === "tiXian") {
        this.queryList();
      } else if (this.searchCondition.status === "menDian") {
        this.queryShopList();
      } else if (this.searchCondition.status === "daoGou") {
        this.queryGuiderList();
      } else if (this.searchCondition.status === "goods") {
        this.queryGoodsList();
      } else if (this.searchCondition.status === "mingxi") {
        this.queryReportListGroup();
      }
    },
    async queryReportListGroup() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.reportListGroup = records;
        this.reportListGroupTotal = total;
      }
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";

      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCommissionReportList", params);
    },
    async queryGoodsList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGoodsReportList",
        params
      );
      this.goodsReportList = result;
    },
    queryGoodsAllList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllGoodsReportList", params);
    },
    queryShopList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryShopReportList", params);
    },
    queryGuiderList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryGuiderReportList", params);
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCommissionReportList", params);
    },
    async queryAllReportListGroup() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findAllCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records } = result;
        return records;
      }
    },
    queryAllShopList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllShopReportList", params);
    },
    queryAllGuiderList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      searchCondition.tradeTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.receiptStartDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[0]
          : "";
      searchCondition.receiptEndDate =
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
          ? this.searchCondition.receiptDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllGuiderReportList", params);
    },

    // 导出excel
    async output() {
      let params = {
        storeCode: this.$route.query.storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.searchCondition.status === "goods") {
        searchCondition.tradeTimeStart =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        Object.assign(params, searchCondition);
        await this.$store.dispatch("redpackageGoodsReportList", params);
      } else if (this.searchCondition.status === "tiXian") {
        searchCondition.tradeTimeStart =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        Object.assign(params, searchCondition);
        await this.$store.dispatch("redpackageCommissionReportList", params);
      } else if (this.searchCondition.status === "menDian") {
        if (typeof searchCondition.citys === "object") {
          searchCondition.shopProvinceCode = searchCondition.citys[0];
          searchCondition.shopCityCode = searchCondition.citys[1];
          searchCondition.shopDistrictCode = searchCondition.citys[2];
        }
        searchCondition.tradeTimeStart =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        Object.assign(params, searchCondition);
        await this.$store.dispatch("redpackageShopReportList", params);
      } else if (this.searchCondition.status === "daoGou") {
        if (typeof searchCondition.citys === "object") {
          searchCondition.shopProvinceCode = searchCondition.citys[0];
          searchCondition.shopCityCode = searchCondition.citys[1];
          searchCondition.shopDistrictCode = searchCondition.citys[2];
        }
        searchCondition.tradeTimeStart =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        Object.assign(params, searchCondition);
        await this.$store.dispatch("redpackageGuiderReportList", params);
      } else if (this.searchCondition.status === "mingxi") {
        searchCondition.tradeTimeStart =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        Object.assign(params, searchCondition);
        await this.$store.dispatch(
          "redpackageCommissionReportListGroupByReward",
          params
        );
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
      // if (this.searchCondition.status === "tiXian") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.tixian.columns
      //           .map(
      //             o => o.label !== "序号" && o.label !== "平台服务费" && o.label
      //           )
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.tixian.$children
      //             .map(
      //               o => o._props.prop !== "percentageMoney" && o._props.prop
      //             )
      //             .filter(o => o);
      //         }
      //         let title = "申报明细";
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           title + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "menDian") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllShopList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.mendian.columns
      //           .map(
      //             o => o.label !== "序号" && o.label !== "平台服务费" && o.label
      //           )
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.mendian.$children
      //             .map(
      //               o => o._props.prop !== "percentageMoneys" && o._props.prop
      //             )
      //             .filter(o => o);
      //         }
      //         let title = "门店统计";
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           title + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "daoGou") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllGuiderList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.daogou.columns
      //           .map(
      //             o => o.label !== "序号" && o.label !== "平台服务费" && o.label
      //           )
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.daogou.$children
      //             .map(
      //               o => o._props.prop !== "percentageMoneys" && o._props.prop
      //             )
      //             .filter(o => o);
      //         }
      //         let title = "导购统计";
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           title + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "goods") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryGoodsAllList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.goods.columns
      //           .map(
      //             o => o.label !== "序号" && o.label !== "平台服务费" && o.label
      //           )
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.goods.$children
      //             .map(
      //               o => o._props.prop !== "percentageMoneys" && o._props.prop
      //             )
      //             .filter(o => o);
      //         }
      //         let title = "商品统计";
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(
      //           tHeader,
      //           data,
      //           title + new Date().toLocaleString()
      //         );
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "mingxi") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllReportListGroup()
      //       .then(res => {
      //         let list = res;
      //         let tHeader = this.$refs.mingxi.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.mingxi.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }
      //         let title = "供货商明细";
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped></style>
